import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigService } from '@finder/core/config.service';
import { API_CONSTANTS, CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import getApiBase from '@finder/shared/utils/string/getApiBase';
import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';

const apiUrlKey = CONFIG_CONSTANTS.apiUrlKey;
const currencyConverterEndpoint = API_CONSTANTS.currencyExchangeRateEndpoint;
const defaultVersionKey = CONFIG_CONSTANTS.defaultVersionKey;
const siteId = CONFIG_CONSTANTS.siteIdKey;

@Injectable()
export class CurrencyConverterService {

    baseUrl: string;
    version: string;
    siteId: string;

    constructor(
        private http: HttpClient,
        private config: ConfigService,
        private localeService: LocaleService,
    ) {
        this.baseUrl = this.config.getValue(apiUrlKey);
        this.version = this.config.getValue(defaultVersionKey);
        this.siteId = this.config.getValue(siteId);
    }

    getExchangeRate(): Observable<any> {
        const apiBase = getApiBase(this.baseUrl, this.version);
        const locale = this.localeService.getLocale();
        const url = `${apiBase}/${currencyConverterEndpoint}/${this.siteId}/${locale}`;

        return this.http.get(url);
    }
}
